import { render } from "./JsCodeEditor.vue?vue&type=template&id=798afdba&scoped=true"
import script from "./JsCodeEditor.vue?vue&type=script&lang=js"
export * from "./JsCodeEditor.vue?vue&type=script&lang=js"

import "./JsCodeEditor.vue?vue&type=style&index=0&id=798afdba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798afdba"]])

export default __exports__